// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"5a672370","199":"083dbcf8","231":"78bab3b4","453":"258b012d","553":"df4143bb","586":"0c56488d","601":"2d98c287","649":"38522cd2","891":"c27ff356"}[chunkId] + ".chunk.js";
};